export default function detachMaster(videoOutputs) {
  const master = videoOutputs.find((output) => output.isMaster);

  const withoutMaster = master ?
  videoOutputs.filter((output) => output.outputId !== master.outputId) :
  [];

  return {
    master,
    withoutMaster
  };
}